import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler, HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from "@angular/core";

import { AuthService } from "./auth.service";
import {_throw} from 'rxjs/observable/throw';
import {environment} from '../../environments/environment';
import {catchError} from 'rxjs/operators';
import {DialogsService} from '../dialogs/dialogs.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private errorService: DialogsService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const authToken = this.authService.getToken();
        const url = req.url.toLowerCase();

        if (authToken && url.search(environment.apiUrl) === 0) {
            // console.log('AuthInterceptor', url, authToken);
            // console.log('intercept b', url);
            const authRequest = req.clone({
                headers: req.headers.set('Authorization', 'Bearer ' + authToken)
            });
            return next.handle(authRequest);
        } else {
            return next.handle(req);
        }
    }
}
